/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import moment from "moment";

import useApiOrderToCash from "../../api/operaciones/useApiOrderToCash";
import {useLoadingDispatch} from "../../layout/show-loading-context";
import {pendientes} from "./OrderToCashConstants";

const opciones = [
    {
        label: "Recepción de documentos",
        value: pendientes.recepcionDocumentos
    },
    {
        label: "Envío a cliente",
        value: pendientes.envioCliente
    }
];

const crearFila = () => ({
    cartaPorte: "",
    fecha: ""
});

const crearFilasIniciales = () =>
    Array.from({length: 3}, () => crearFila());

const FechasMasivas = ({
    visible,
    onCancel,
    onSaved
}) => {
    const api = useApiOrderToCash();
    const dispatch = useLoadingDispatch();

    const [tipoEvento, setTipoEvento] = useState(
        pendientes.recepcionDocumentos
    );

    const [registros, setRegistros] = useState(
        crearFilasIniciales
    );

    const [resultados, setResultados] = useState(null);
    const [visibleReporte, setVisibleReporte] =
        useState(false);

    useEffect(() => {
        if (visible) {
            setRegistros(crearFilasIniciales());
            setResultados(null);
        }
    }, [visible]);

    const actualizarRegistro = (
        index,
        propiedad,
        valor
    ) => {
        setRegistros((anteriores) =>
            anteriores.map((registro, registroIndex) =>
                registroIndex === index
                    ? {
                        ...registro,
                        [propiedad]: valor
                    }
                    : registro
            )
        );
    };

    const convertirFechaExcel = (valor) => {
        const texto = valor?.trim();

        if (!texto) {
            return "";
        }

        /*
         * Cuando Excel copia una fecha como número serial.
         * Ejemplo: 45515.5
         */
        if (/^\d+(\.\d+)?$/.test(texto)) {
            const numeroExcel = Number(texto);

            if (numeroExcel > 20000) {
                const milisegundos = Math.round(
                    (numeroExcel - 25569) *
                    86400 *
                    1000
                );

                return moment
                    .utc(milisegundos)
                    .format("YYYY-MM-DD");
            }
        }

        const formatosPermitidos = [
            "DD/MM/YYYY HH:mm:ss",
            "DD/MM/YYYY HH:mm",
            "DD/MM/YYYY",
            "D/M/YYYY HH:mm:ss",
            "D/M/YYYY HH:mm",
            "D/M/YYYY",
            "YYYY-MM-DD HH:mm:ss",
            "YYYY-MM-DD HH:mm",
            "YYYY-MM-DD"
        ];

        const fecha = moment(
            texto,
            formatosPermitidos,
            true
        );

        return fecha.isValid()
            ? fecha.format("YYYY-MM-DD")
            : "";
    };

    const pegarColumnaDesdeExcel = (
        event,
        filaInicial,
        columna
    ) => {
        event.preventDefault();

        const textoPegado =
            event.clipboardData.getData("text");

        if (!textoPegado) {
            return;
        }

        /*
         * Excel separa cada fila con un salto de línea.
         * Si vienen varias columnas, únicamente se usa
         * la primera columna copiada.
         */
        const valores = textoPegado
            .replace(/\r/g, "")
            .split("\n")
            .filter((valor, index, arreglo) => {
                const esUltimo =
                    index === arreglo.length - 1;

                return !(esUltimo && valor === "");
            })
            .map((fila) =>
                fila.split("\t")[0].trim()
            );

        setRegistros((registrosAnteriores) => {
            const nuevosRegistros =
                registrosAnteriores.map(
                    (registro) => ({
                        ...registro
                    })
                );

            valores.forEach((valor, index) => {
                const numeroFila =
                    filaInicial + index;

                while (
                    nuevosRegistros.length <= numeroFila
                ) {
                    nuevosRegistros.push(crearFila());
                }

                if (columna === "cartaPorte") {
                    nuevosRegistros[
                        numeroFila
                    ].cartaPorte = valor;
                }

                if (columna === "fecha") {
                    nuevosRegistros[numeroFila].fecha =
                        convertirFechaExcel(valor);
                }
            });

            /*
             * Si la última fila contiene información,
             * se agrega una nueva fila vacía.
             */
            const ultimaFila =
                nuevosRegistros[
                    nuevosRegistros.length - 1
                ];

            if (
                ultimaFila.cartaPorte ||
                ultimaFila.fecha
            ) {
                nuevosRegistros.push(crearFila());
            }

            return nuevosRegistros;
        });
    };

    const validarRegistros = () => {
        const registrosCapturados = registros
            .map((registro) => ({
                cartaPorte:
                    registro.cartaPorte.trim(),
                fecha: registro.fecha || null
            }))
            .filter(
                (registro) =>
                    registro.cartaPorte
            );

        if (registrosCapturados.length === 0) {
            dispatch({
                type: "toast",
                message:
                    "Debes capturar al menos una Carta Porte.",
                severity: "error"
            });

            return null;
        }

        const cartasPorteRepetidas =
            registrosCapturados
                .map(
                    (registro) =>
                        registro.cartaPorte
                )
                .filter(
                    (
                        cartaPorte,
                        index,
                        arreglo
                    ) =>
                        arreglo.indexOf(
                            cartaPorte
                        ) !== index
                );

        if (cartasPorteRepetidas.length > 0) {
            dispatch({
                type: "toast",
                message:
                    `Existen Cartas Porte repetidas: ${
                        [
                            ...new Set(
                                cartasPorteRepetidas
                            )
                        ].join(", ")
                    }.`,
                severity: "error"
            });

            return null;
        }

        return registrosCapturados;
    };

    const onSave = async () => {
        const registrosCapturados =
            validarRegistros();

        if (!registrosCapturados) {
            return;
        }

        try {
            const response =
                await api.registrarFechasMasivas(
                    tipoEvento,
                    {
                        registros:
                            registrosCapturados
                    }
                );

            setResultados(response);
            setVisibleReporte(true);

            if (onSaved) {
                await onSaved();
            }
        } catch (error) {
            dispatch({
                type: "toast",
                message:
                    error?.response?.data?.message ||
                    "Ocurrió un error al registrar las fechas.",
                severity: "error"
            });
        }
    };

    const mostrarFecha = (fecha) => {
        if (!fecha) {
            return "Vacía";
        }

        return moment(fecha).format(
            "DD/MM/YYYY"
        );
    };

    const estiloCelda = {
        padding: 0,
        border: "1px solid #d5d5d5"
    };

    const estiloInput = {
        width: "100%",
        height: "34px",
        padding: "4px 8px",
        border: "none",
        outline: "none",
        boxSizing: "border-box"
    };

    return (
        <>
            <Dialog
                header="Registrar fechas masivas"
                visible={visible}
                style={{width: "900px"}}
                onHide={onCancel}
            >
                <div style={{marginBottom: "16px"}}>
                    <label
                        htmlFor="tipoEvento"
                        style={{
                            display: "block",
                            marginBottom: "6px",
                            fontWeight: "bold"
                        }}
                    >
                        Fecha que se actualizará
                    </label>

                    <Dropdown
                        id="tipoEvento"
                        value={tipoEvento}
                        options={opciones}
                        optionLabel="label"
                        optionValue="value"
                        onChange={(event) =>
                            setTipoEvento(
                                event.value
                            )
                        }
                        style={{width: "100%"}}
                    />
                </div>

                <div
                    style={{
                        maxHeight: "400px",
                        overflowY: "auto",
                        border:
                            "1px solid #d5d5d5"
                    }}
                >
                    <table
                        style={{
                            width: "100%",
                            borderCollapse:
                                "collapse",
                            tableLayout: "fixed"
                        }}
                    >
                        <thead>
                            <tr>
                                <th
                                    style={{
                                        width: "55px",
                                        background:
                                            "#eeeeee",
                                        border:
                                            "1px solid #d5d5d5"
                                    }}
                                />

                                <th
                                    style={{
                                        padding: "8px",
                                        textAlign:
                                            "center",
                                        background:
                                            "#eeeeee",
                                        border:
                                            "1px solid #d5d5d5"
                                    }}
                                >
                                    Carta Porte
                                </th>

                                <th
                                    style={{
                                        padding: "8px",
                                        textAlign:
                                            "center",
                                        background:
                                            "#eeeeee",
                                        border:
                                            "1px solid #d5d5d5"
                                    }}
                                >
                                    Fecha
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {registros.map(
                                (
                                    registro,
                                    index
                                ) => (
                                    <tr key={index}>
                                        <td
                                            style={{
                                                padding:
                                                    "6px",
                                                textAlign:
                                                    "center",
                                                background:
                                                    "#f3f3f3",
                                                border:
                                                    "1px solid #d5d5d5"
                                            }}
                                        >
                                            {index + 1}
                                        </td>

                                        <td
                                            style={
                                                estiloCelda
                                            }
                                        >
                                            <input
                                                type="text"
                                                value={
                                                    registro.cartaPorte
                                                }
                                                placeholder="Pega una columna desde Excel"
                                                title="Puedes pegar una columna desde Excel"
                                                onChange={(
                                                    event
                                                ) =>
                                                    actualizarRegistro(
                                                        index,
                                                        "cartaPorte",
                                                        event
                                                            .target
                                                            .value
                                                    )
                                                }
                                                onPaste={(
                                                    event
                                                ) =>
                                                    pegarColumnaDesdeExcel(
                                                        event,
                                                        index,
                                                        "cartaPorte"
                                                    )
                                                }
                                                style={
                                                    estiloInput
                                                }
                                            />
                                        </td>

                                        <td
                                            style={
                                                estiloCelda
                                            }
                                        >
                                            <input
                                                type="date"
                                                value={
                                                    registro.fecha
                                                }
                                                title="Puedes pegar una columna desde Excel"
                                                onChange={(
                                                    event
                                                ) =>
                                                    actualizarRegistro(
                                                        index,
                                                        "fecha",
                                                        event
                                                            .target
                                                            .value
                                                    )
                                                }
                                                onPaste={(
                                                    event
                                                ) =>
                                                    pegarColumnaDesdeExcel(
                                                        event,
                                                        index,
                                                        "fecha"
                                                    )
                                                }
                                                style={
                                                    estiloInput
                                                }
                                            />
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>

                <small
                    style={{
                        display: "block",
                        marginTop: "10px"
                    }}
                >
                    Copia una columna de Excel y
                    pégala en la primera celda de
                    Carta Porte. Después haz lo
                    mismo con la columna Fecha.
                </small>

                <div
                    style={{
                        display: "flex",
                        justifyContent:
                            "flex-end",
                        gap: "8px",
                        marginTop: "20px"
                    }}
                >
                    <Button
                        label="Cancelar"
                        icon="pi pi-times"
                        className="p-button-text"
                        type="button"
                        onClick={onCancel}
                    />

                    <Button
                        label="Guardar"
                        icon="pi pi-save"
                        type="button"
                        onClick={onSave}
                    />
                </div>
            </Dialog>

            <Dialog
                header="Resultado de fechas masivas"
                visible={visibleReporte}
                style={{width: "950px"}}
                onHide={() =>
                    setVisibleReporte(false)
                }
            >
                {resultados && (
                    <>
                        <div
                            style={{
                                marginBottom:
                                    "12px"
                            }}
                        >
                            <b>Actualizados:</b>{" "}
                            {
                                resultados.resumen
                                    .totalActualizados
                            }
                            {" | "}
                            <b>Eliminados:</b>{" "}
                            {
                                resultados.resumen
                                    .totalEliminados
                            }
                            {" | "}
                            <b>Omitidos:</b>{" "}
                            {
                                resultados.resumen
                                    .totalOmitidos
                            }
                            {" | "}
                            <b>Errores:</b>{" "}
                            {
                                resultados.resumen
                                    .totalErrores
                            }
                        </div>

                        <div
                            style={{
                                maxHeight:
                                    "450px",
                                overflowY: "auto"
                            }}
                        >
                            <table className="table table-borderless">
                                <thead className="thead-light">
                                    <tr>
                                        <th>Fila</th>
                                        <th>
                                            Carta porte
                                        </th>
                                        <th>Viaje</th>
                                        <th>Estado</th>
                                        <th>
                                            Fecha anterior
                                        </th>
                                        <th>
                                            Fecha solicitada
                                        </th>
                                        <th>Mensaje</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {resultados.detalles.map(
                                        (
                                            detalle,
                                            index
                                        ) => (
                                            <tr
                                                key={
                                                    index
                                                }
                                            >
                                                <td>
                                                    {
                                                        detalle.fila
                                                    }
                                                </td>

                                                <td>
                                                    {
                                                        detalle.cartaPorte
                                                    }
                                                </td>

                                                <td>
                                                    {
                                                        detalle.viajeId
                                                    }
                                                </td>

                                                <td>
                                                    {
                                                        detalle.estado
                                                    }
                                                </td>

                                                <td>
                                                    {mostrarFecha(
                                                        detalle.fechaAnterior
                                                    )}
                                                </td>

                                                <td>
                                                    {mostrarFecha(
                                                        detalle.fechaSolicitada
                                                    )}
                                                </td>

                                                <td>
                                                    {
                                                        detalle.mensaje
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </Dialog>
        </>
    );
};

export default FechasMasivas;
